import React, { useRef, useState } from 'react'
import { useHistory, Link } from 'react-router-dom'
import PageHeading from '../pageHeading/PageHeading'
import { useAuth } from '../../../context/AuthContext'

const SignIn = () => {
	const { signin } = useAuth()
	const history = useHistory()
	const emailRef = useRef()
	const passwordRef = useRef()
	const [loading, setLoading] = useState(false)

	const handleSubmit = async (event) => {
		setLoading(true)
		event.preventDefault()
		try {
			await signin(emailRef.current.value + "@kuf.fi", passwordRef.current.value)
			history.push('/')
		} catch (error) {
			console.error(error)
			alert('error!')
			setLoading(false)
		}
	}
	return (
		<div className="AppContents">
			<div className="Container">
				<PageHeading heading={'Logga in'} />
				<section>
					<div>
						<label>Användarnamn</label>
						<input ref={emailRef} type="text" placeholder="Användarnamn" />
					</div>
					<div>
						<label>Lösenord</label>
						<input
							ref={passwordRef}
							type="password"
							placeholder="Lösenord"
						/>
					</div>
				</section>
				<section>
					<button onClick={(e) => handleSubmit(e)} disabled={loading}>
						Logga in
					</button>
				</section>
				<section>
					inget konto? <Link to="/signup">Skapa konto</Link>
				</section>
			</div>
		</div>
	)
}
export default SignIn
